module.exports = __webpack_public_path__ + "static/img/che10.bd8e6e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/che10.png
// module id = LQ8C
// module chunks = 1